<template>
  <el-dialog
    custom-class="dialog-authentication"
    lock-scroll
    :modal-append-to-body="true"
    :append-to-body="true"
    title=""
    width="500px"
    :close-on-click-modal="false"
    :visible="value"
    @close="closeDialog"
    :show-close="false"
    v-if="ishow"
  >
    <div>
      <div class="title">{{ $lang("身份验证") }}</div>
      <div class="tip">
        {{
          $lang(
            "系统检测到您本次登录设备和上次不一致，为了保护您的账号安全，系统需要验证您的身份，验证通过后即可使用系统。"
          )
        }}
      </div>
      <div class="tabs">
        <div
          v-for="(item, index) in tabs"
          :key="index"
          :class="{
            'tabs-item': true,
            'tabs-item-active': tabActive === item.value
          }"
          @click="tabsHandle(item.value)"
        >
          {{ $lang(item.label) }}
        </div>
      </div>
      <div v-if="tabActive === 1">
        {{ $lang("您在系统中绑定的邮箱为：") }}{{ contactInfo.emailMask }}
      </div>
      <div v-if="tabActive === 2">
        {{ $lang("您在系统中绑定的手机号为：") }}
        {{ contactInfo.phoneMask }}
      </div>
      <div class="code" v-if="!isSendCode" @click="getCode">
        <el-button type="text" :loading="sendCodeLoading">{{
          $lang("获取验证码")
        }}</el-button>
      </div>
      <div v-else class="code-time">
        <span>{{ time }}</span
        >{{ $lang("秒后可重新获取验证码") }}
      </div>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="" prop="fingerPrint">
          <el-input
            v-model="form.fingerPrint"
            :placeholder="$lang('请输入验证码')"
            maxlength="10"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $lang("取消") }}</el-button>
      <el-button type="primary" :loading="btnLoading" @click="sumitForm">{{
        $lang("提交")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as Api from "@/api";
import {
  RESPONSE_SUCCESS,
  RESPONSE_RESETPASSWORD,
  RESPONSE_PASSWORDNOTRULES
} from "@/constants";
import { RULES } from "@/constants/rules";
import mixin from "@/mixin/tencentCaptcha";
import { AESUtil } from "@/utils/";
const emailTab = { label: "邮箱验证", value: 1 };
const phoneTab = { label: "手机号验证", value: 2 };
export default {
  name: "DialogAuthentication",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loginForm: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mixins: [mixin],
  data() {
    return {
      tabs: [],
      form: {
        fingerPrint: null
      },
      btnLoading: false,
      tabActive: 1,
      isSendCode: false,
      codeTimer: null,
      time: 120,
      customParams: {},
      contactInfo: {},
      ishow: false,
      sendCodeLoading: false
    };
  },
  watch: {
    value: {
      handler(val) {
        val && this.getContact();
      }
    }
  },
  computed: {
    rules() {
      return {
        fingerPrint:
          this.tabActive === 1 ? [RULES.emailCode] : [RULES.phoneCode]
      };
    }
  },
  methods: {
    closeDialog() {
      this.sendCodeLoading = false;
      this.$emit("input", false);
      this.form = {
        fingerPrint: null
      };
      this.ishow = false;
      this.$refs.form.resetFields();
    },
    tabsHandle(index) {
      this.tabActive = index;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    getCode() {
      this.captchaType = 1;
      this.captcha.show();
    },
    async getContact() {
      try {
        const params = {
          account: this.loginForm.account
        };
        const { code, data, msg } = await Api.getContact(params);
        if (code === RESPONSE_SUCCESS) {
          if (data.email && data.phone) {
            // 如果同时存在邮箱和手机验证
            this.tabActive = 1;
            this.tabs = [emailTab, phoneTab];
            this.ishow = true;
          } else if (data.email && !data.phone) {
            // 如果仅存在邮箱验证
            this.tabActive = 1;
            this.tabs = [emailTab];
            this.ishow = true;
          } else if (data.phone && !data.email) {
            // 如果仅存在手机验证
            this.tabActive = 2;
            this.tabs = [phoneTab];
            this.ishow = true;
          } else {
            this.$message.warning(this.$lang("账户未绑定有效联系方式（邮箱/手机号）,请联系管理员！"));
            this.tabs = [];
            this.ishow = false;
          }
          this.contactInfo = data;
        } else {
          this.tabs = [];
          this.$message.error(this.$lang(msg));
        }
      } catch (error) {
        this.tabs = [];
      }
    },
    async sendCode(customParams) {
      this.customParams = customParams;
      if (this.captchaType === 1) {
        this.getFingerPrint();
      }
      if (this.captchaType === 2) {
        this.login();
      }
    },
    async getFingerPrint() {
      try {
        const params = { ...this.customParams };
        if (this.tabActive === 1) {
          params.type = 4;
          params.emailEncrypt = this.contactInfo.email;
        }
        if (this.tabActive === 2) {
          params.type = "login_finger_print";
          params.phoneEncrypt = this.contactInfo.phone;
        }
        const apiMap = {
          1: Api.sendEmail,
          2: Api.sendSms
        };
        this.sendCodeLoading = true;
        const { code, msg } = await apiMap[this.tabActive](params);
        this.sendCodeLoading = false;
        if (code === RESPONSE_SUCCESS) {
          this.isSendCode = true;
          this.time = 120;
          clearInterval(this.codeTimer);
          this.codeTimer = setInterval(() => {
            this.time--;
            if (this.time === 0) {
              this.isSendCode = false;
              this.time = 120;
            }
          }, 1000);
          this.$message.success(this.$lang(msg));
        } else {
          this.$message.error(this.$lang(msg));
        }
      } catch (error) {
        this.sendCodeLoading = false;
      }
    },
    sumitForm() {
      try {
        this.$refs.form.validate((vaild) => {
          if (!vaild) return;
          this.captchaType = 2;
          this.captcha.show();
        });
      } catch (error) {
        console.log(error);
      }
    },
    async login() {
      try {
        const params = { ...this.customParams, ...this.form };
        params.account = this.loginForm.account;
        params.password = AESUtil.aesEncrypt(this.loginForm.password);
        if (this.tabActive === 1) {
          params.emailEncrypt = this.contactInfo.email;
        }
        if (this.tabActive === 2) {
          params.phoneEncrypt = this.contactInfo.phone;
        }
        this.btnLoading = true;
        const res = await Api.login(params);
        this.btnLoading = false;
        if (res.code === RESPONSE_SUCCESS || res.code === RESPONSE_PASSWORDNOTRULES || res.code === RESPONSE_RESETPASSWORD) {
          this.$emit("input", false);
        }
        this.$emit("success", res);
      } catch (error) {
        this.btnLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dialog-authentication {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0 20px;
  }
  .title {
    padding-top: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #2b2d42;
  }
  .tip {
    margin-top: 10px;
    color: #2b2d42;
  }
  .tabs {
    padding: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .tabs-item {
    cursor: pointer;
    margin-right: 20px;
  }
  .tabs-item-active {
    color: #c31422;
  }
  .code {
    cursor: pointer;
    margin-top: 10px;
    color: #c31422;
  }
  .code-time {
    margin-top: 10px;
  }
  .country-code {
    width: 80px;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-input__icon {
      line-height: 30px;
    }
  }
  .el-form {
    margin-top: 20px;
  }
  .el-form-item__content {
    height: 30px;
    line-height: 30px;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
